export const en = {
  Navbar: {
    about_TOEIC: 'About TOEIC',
    must_know_vocabulary: 'Must-know Vocabulary'
  },
  Overview: {
    classify: 'Classify',
    time: 'Time',
    course: 'Course',
    practice: 'Practice',
    exam: 'Exam',
    exam_score: 'Exam score',
    exam_advance: 'Advance',
    exam_advance_with_percent: 'Advance with percent'
  },
  Login: {
    register: 'Register',
    trial: 'Sigh up for free trial',
    login: 'Log In',
    start_my_course: 'Start my course',
    please_enter_your_email: 'Please enter your email',
    please_enter_password: 'Please enter password'
  },
  Home: {
    Daily_English: 'Daily English',
    World_News: 'World News',
    Lets_play_in_English: "Let's play in English",
    FunEnglish: 'Come and play games, learn vocabularies, and develop your sense of English with teacher!',
    Learning_History: 'Learning History',
    Latest_Courses: 'Latest Courses',
    Recommend: 'Recommend',
    Learning_Guides: 'Learning Guides',
    Go_to_course: 'Go to course',
    Play: 'Play',
    Keep: 'Keep',
    watch_more: 'watch more'
  },
  Personal: {
    Info: {
      Total_study_time: 'Total study time',
      Number_of_courses_passed: 'Number of courses passed',
      Number_of_monthly_exams: 'Number of monthly exams',
      First_time_login: 'First time login'
    },
    Target: {
      Goal: 'Goal',
      Completed: 'Completed',
      Result: 'Result',
      Marks: 'marks',
      Unit: 'unit(s)',
      Time: 'time(s)'
    },
    Record: {
      Learning_records: 'Learning records',
      View_all: 'View all',
      Date_settings: 'Date_settings',
      Learning_hours: 'Learning_hours',
      Number_of_completed_courses: 'Number of completed courses',
      Number_of_unit_tests_passed: 'Number of unit tests passed',
      Details: 'Details',
      Course_categories: 'Course categories',
      History: 'History',
      Unit_test_score: 'Unit test score',
      Go_to_course: 'Go to course'
    },
    Collection: {

    },
    Exam: {
      Exam: 'Exam',
      Placement_test: 'Placement test',
      Result: 'Result',
      Exam_date: 'Exam date',
      Answering_time: 'Answering time',
      Listening_score: 'Listening score',
      Reading_score: 'Reading score',
      Total_score: 'Total score',
      Monthly_mock_test: 'Monthly mock test',
      More_practice: 'More practice',
      Updated_exam_date: 'Updated exam date',
      Number_of_exercises: 'Number of exercises',
      Start: 'Start',
      Details: 'Details'
    }
  }
}
